import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/cargo_sources',
    name: 'cargo_source',
    component: {
      name: 'AdminCargoSource',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'cargo_source',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminCargoSourceIndex',
        component: () => import('../views/CargoSourceIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminCargoSourceNew',
        component: () => import('../views/CargoSourceInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminCargoSourceIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminCargoSourceShow',
        component: () => import('../views/CargoSourceShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminCargoSourceIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminCargoSourceDetails',
            component: () => import('../views/CargoSourceDetails.vue'),
            meta: {
              backRoute: { name: 'AdminCargoSourceIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminCargoSourceEdit',
            component: () => import('../views/CargoSourceInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminCargoSourceDetails' },
            },
          },
          {
            path: 'cargo_source_accounts',
            name: 'CargoSourceAccounts',
            component: {
              name: 'AdminCargoSourceAccount',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminCargoSouceIndex' },
              resource: 'cargo_source_account',
            },
            children: [
              {
                path: '',
                name: 'AdminCargoSourceAccounts',
                component: () => import('../views/cargoSourceAccount/CargoSourceAccountIndex.vue'),
                meta: {
                  backRoute: { name: 'AdminCargoSourceIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminCargoSourceAccountNew',
                component: () => import('../views/cargoSourceAccount/CargoSourceAccountInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminCargoSourceIndex' },
                },
              },
              {
                path: ':cargoSourceAccountId(\\d+)',
                name: 'AdminCargoSourceAccountShow',
                component: () => import('../views/cargoSourceAccount/CargoSourceAccountShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminCargoSourceAccounts',
                  },
                  tArgs: route => ({ name: route?.params?.cargoSourceAccountId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminCargoSourceAccountDetails',
                    component: () => import('../views/cargoSourceAccount/CargoSourceAccountDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminCargoSourceAccounts' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminCargoSourceAccountEdit',
                    component: () => import('../views/cargoSourceAccount/CargoSourceAccountInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminCargoSourceAccountDetails' },
                    },
                  },      
                ],
              },
            ]
          },
          {
            path: 'cargo_source_jetties',
            name: 'CargoSourceJetties',
            component: {
              name: 'AdminCargoSourceJetty',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminCargoSouceIndex' },
              resource: 'cargo_source_jetty',
            },
            children: [
              {
                path: '',
                name: 'AdminCargoSourceJetties',
                component: () => import('../views/cargoSourceJetty/CargoSourceJettyIndex.vue'),
                meta: {
                  backRoute: { name: 'AdminCargoSourceIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminCargoSourceJettyNew',
                component: () => import('../views/cargoSourceJetty/CargoSourceJettyInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminCargoSourceIndex' },
                },
              },
              {
                path: ':cargoSourceJettyId(\\d+)',
                name: 'AdminCargoSourceJettyShow',
                component: () => import('../views/cargoSourceJetty/CargoSourceJettyShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminCargoSourceJetties',
                  },
                  tArgs: route => ({ name: route?.params?.cargoSourceJettyId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminCargoSourceJettyDetails',
                    component: () => import('../views/cargoSourceJetty/CargoSourceJettyDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminCargoSourceJetties' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminCargoSourceJettyEdit',
                    component: () => import('../views/cargoSourceJetty/CargoSourceJettyInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminCargoSourceJettyDetails' },
                    },
                  },      
                ],
              },
            ]
          },
        ],
      },
    ]
  },
];
OCRoutes.forEach(route => router.addRoute('OC', route));
